import React, { useEffect } from 'react';
import { Button, Form, Input, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import TagInput from '../Elements/TagInput';
const RiderForm = ({ handleSubmit, action, rider, handleCancel, isFetching }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation('drivers');
  const { t: tc } = useTranslation('common');

  const [skills, setSkills] = React.useState([]);

  const setParams = (values) => {
    const params = { ...values, skills };
    return params;
  };
  const onFinishForm = (values) => {
    handleSubmit && handleSubmit(setParams(values));
  };

  useEffect(() => {
    if (action === 'new') {
      form.setFieldsValue({ name: null, email: null, phone: '+41' });
    } else if (rider) {
      form.setFieldsValue({
        ...rider,
      });
      setSkills(rider.skills || []);
    }
  }, [action, rider]);

  return (
    <Spin spinning={isFetching}>
      <div className="RiderForm">
        <div className="FormHeader"></div>
        <div className="FormContent">
          <Form
            form={form}
            scrollToFirstError
            layout="vertical"
            requiredMark={false}
            colon={false}
            onFinish={onFinishForm}
          >
            <Form.Item
              label={t('email')}
              name="email"
              rules={[
                { required: true, message: tc('required') },
                { type: 'email', message: tc('invalidEmail') },
              ]}
            >
              <Input placeholder={t('email')} />
            </Form.Item>
            <Form.Item
              label={t('password')}
              name="password"
              rules={[{ required: action === 'new' || (action !== 'new' && !rider?.email), message: tc('required') }]}
            >
              <Input.Password placeholder={t('password')} autoComplete="new-password" />
            </Form.Item>
            <Form.Item label={t('name')} name="name" rules={[{ required: true, message: tc('required') }]}>
              <Input placeholder={t('name')} />
            </Form.Item>
            <Form.Item label={t('phoneNumber')} name="phone">
              <PhoneInput
                country={'ch'}
                prefix="+"
                specialLabel=""
                countryCodeEditable
                enableSearch
                disableSearchIcon
              />
            </Form.Item>
            <Form.Item label={t('skills')} name="skills">
              <TagInput tags={skills} onChange={(values) => setSkills(values)} />
            </Form.Item>
          </Form>
        </div>
        <div className="FormFooter">
          <Button key="cancel" onClick={handleCancel}>
            {tc('cancel')}
          </Button>
          <Button type="primary" block size="large" onClick={() => form.submit()}>
            {action === 'new' ? tc('create') : tc('update')}
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default RiderForm;
